import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CISCompliance {
  CISComplianceSelectedRowID: string;
}

const initialState: CISCompliance = {
    CISComplianceSelectedRowID: "",
};

const CISComplianceSeleted = createSlice({
  name: "CompliancTableSelectedRow",
  initialState,
  reducers: {
    setComplianceTableRowId(state, action: PayloadAction<{ CISComplianceSelectedRowID: string }>) {
      state.CISComplianceSelectedRowID = action.payload.CISComplianceSelectedRowID;
    },
  },
});

export const { setComplianceTableRowId } = CISComplianceSeleted.actions;
export default CISComplianceSeleted.reducer;
